class WriteOffNote {
    id = null;
    number = '';
    time_of_issue = null;
    reason = '';
    write_off_note_sequence_id = null;
    locale = '';
    items = [];
    cancels = 0;
    cancelled_by = 0;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default WriteOffNote;
